import { Link } from "react-router-dom";
import type { KbDuplicateExisting } from "@/api/knowledge";

/**
 * D-147 W1 S4 — ЄДИНИЙ діалог дублікатів (visual package ⑤ «Дублікати — ДВА
 * чеки»; той самий патерн для page-title, file-hash і file-title): явний вибір
 * «Відкрити наявний» / «…як окремий» (= confirm-override retry; backend
 * аудитить kb_duplicate_override). Жодного silent-override.
 */
export function KbDuplicateDialog({
  kind,
  existing,
  confirmLabel,
  onConfirm,
  onCancel,
  busy,
}: {
  kind: "file" | "title";
  existing: KbDuplicateExisting | null;
  /** «Завантажити як окремий» / «Створити як окремий» / «Опублікувати як окремий». */
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  busy?: boolean;
}) {
  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Знайдено дублікат"
    >
      <div className="w-full max-w-md rounded-xl border bg-card p-5 shadow-2xl">
        <div className="text-sm font-semibold">
          {kind === "file" ? "Цей самий файл уже завантажено" : "Матеріал зі схожою назвою вже існує"}
        </div>
        {existing && (
          <p className="mt-1.5 text-sm text-muted-foreground">
            Наявний матеріал: «{existing.title || existing.itemId}»
          </p>
        )}
        <div className="mt-4 flex flex-wrap justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-md px-3.5 py-2 text-sm font-medium text-muted-foreground hover:bg-muted"
          >
            Скасувати
          </button>
          {existing && (
            <Link
              to={`/knowledge/items/${existing.itemId}`}
              className="rounded-md border px-3.5 py-2 text-sm font-medium hover:bg-accent"
            >
              Відкрити наявний
            </Link>
          )}
          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            className="rounded-md bg-primary px-3.5 py-2 text-sm font-semibold text-primary-foreground disabled:opacity-50"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
